// @flow
import React, { useContext } from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Button } from 'Components/frameworks/button/Button';
import { COLORS } from 'Components/utils/color/colors';
import { Text } from 'Components/frameworks/text/Text';
import { ReactPageContext } from 'Context/pageContext';

type Props = {
  buttonLabel: string,
  buttonLink: string,
  title: string,
};
export const ButtonTicketLine = ({ buttonLabel, buttonLink, title }: Props) => {
  const { pageType } = useContext(ReactPageContext);

  const trackingData = {
    categoryGA: pageType,
    actionGA: 'priceBar',
    labelGA: 'getAQuote',
  };

  return (
    <SiteContainer className="Line Line-ButtonTicket">
      <div className="bg-white shadow-diffuse rounded-tiny border-1 border-gray-light flex items-center p-3 flex-col md:flex-row mt-8 md:mt-0">
        <Text
          className="flex-1 md:rtl:ml-2 text-center md:text-initial px-3 md:px-0"
          text={title}
        />
        <Button
          colorBg={COLORS.BOOKING}
          url={buttonLink}
          trackingData={trackingData}
          dataTestId="getButtonTicketLineBtn"
          className="w-full md:w-auto mt-4 sm:mt-0"
        >
          {buttonLabel}
        </Button>
      </div>
    </SiteContainer>
  );
};
